export default Object.freeze({
  Disabled: 0,
  ReadOnly: 1,
  AppendOnly: 2,
  Delete: 3,
  Edit: 4,
  EditAndDelete: 5,
});
